import React, { useState } from "react";
import axios from "../../../library/axios";
import { MySwal } from "../../../library/swal";
import Button from "react-bootstrap/Button";
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const ImportMasterStandards = (props) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [file, setfile] = useState("");

  const handleImport = async () => {
    try {
      setDisabled(true);
      setLoading(true);
      //   console.log(file);
      //   return false;
      if (file === "") {
        MySwal.fire({
          icon: "error",
          title: "Oops, Error",
          text: "Belum ada file terupload!",
        });
        return false;
      }

      const formData = new FormData();
      formData.append("filePath", file);

      // Display the key/value pairs
      // for (var pair of formData.entries()) {
      //     console.log(pair[0] + ', ' + pair[1]);
      // }
      // return false

      const { data } = await axios({
        url: `/standar-akreditasi/importStandarAkreditasi`,
        method: "POST",
        data: formData,
        headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
      });
      // console.log(data)
      // return false
      MySwal.fire({
        icon: "success",
        title: "Sukses",
        text: "Berhasil mengimport data!",
      });
      props.fetch();
      props.close();
      setDisabled(false);
      setLoading(false);
    } catch (err) {
      console.log(err?.response?.data?.message);
      MySwal.fire({
        icon: "error",
        title: "Oops, Error!",
        text: `${err?.response?.data?.message}`,
      });
      setDisabled(false);
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="mb-3 row">
        <label htmlFor="filePath" className="col-sm-2 col-form-label">
          File
        </label>
        <div className="col-12">
          <input
            type="file"
            className="form-control"
            id="filePath"
            onChange={(e) => setfile(e.target.files[0])}
          />
        </div>
      </div>
      <div className="mt-5 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={disabled}
            variant="success"
            size="sm"
            onClick={() => handleImport()}
          >
            {loading === true ? "Mohon Tunggu.." : "Simpan"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImportMasterStandards;
